<template>
  <div class="loginContainer">
    <div style="margin-left: 40%; font-size: 25px;">
      <!-- <H1>砍树挂号管家</H1> -->
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="已有用户" name="first">
        <div>
          <div>
              <el-form :inline="true" label-position="right" size="default">
                <el-row :gutter="24">
                  <el-col :span="6" class="panda-search-row-input-group" style="width: 250px;">
                    <el-form-item label="" style="width: 100%;">
                      <el-input style="width: 100%;" v-model="searchValue.loginId" class="panda-search-item" placeholder="账号" clearable/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="14" type="flex" class="panda-search-row-button-group" justify="end">
                    <el-form-item>
                      <!-- <el-button size="medium" type="primary" @click="ZhOne">查 询</el-button> -->
                      <el-button size="medium" type="primary" @click="chaxunBs(1)">查询全部账号</el-button>
                      <!-- <el-button size="medium" type="primary" @click="addZh">添加账号</el-button> -->
                      

                      <el-button size="medium" type="primary" @click="checkQuery">勾选查询</el-button>
                      <el-button size="medium" type="primary" @click="checkExportExcel">勾选导出为Excel</el-button>
                      <el-button size="medium" type="primary" @click="checkExport">勾选导出配置</el-button>
                      <el-button size="medium" type="primary" @click="checkImport">导入配置</el-button>


                      <el-upload
                          hidden  
                          ref="uploadRef"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :action="uploadUrl"
                          accept=".json"
                          :limit="1"/>

                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>

            <div>
              <el-table max-height="640" @selection-change="handleSelectionChange" v-loading="loading"
                  element-loading-text="正在加载..."
                  element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="items" stripe  border size="default" style="width: 81%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column align="center" label="序号" >
                  <template #default="scope">
                    {{(scope.$index + 1)}}
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="username" label="账号"/>
                <el-table-column align="center" prop="serverName" label="区服" />
                <el-table-column align="center" prop="nickName" label="角色名"  />
                <el-table-column align="center" prop="enabled" label="启用状态" >
                  <template #default="scope">
                    <el-tag v-if="scope.row.enabled" type="success">已开启</el-tag>
                    <el-tag v-else type="danger">未开启</el-tag>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="startDate" label="剩余天数" sortable :formatter="shengyutianshu"/>
                <el-table-column align="center" prop="startDate" label="生效时间" />
                <el-table-column align="center" prop="startDate" label="是否极限福地" >
                  <template #default="scope">
                    <el-tag v-if="scope.row.homeland_2200_0100 
                    && scope.row.homeland_0100_0300 
                    && scope.row.homeland_0300_0700
                    && !scope.row.homeland_1030_1400
                    && !scope.row.homeland_1400_1600
                    && !scope.row.homeland_1800_1930" 
                    type="danger">不是</el-tag>
                    <el-tag v-else type="success">是</el-tag>
                  </template>
                </el-table-column>
                <el-table-column align="center" fixed="right" label="操作" width="150px">
                  <template #default="scope">
                      <el-dropdown trigger="click">
                        <el-button size="small" type="primary">
                          操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item @click.native="zhBJ(scope.row)">脚本设置</el-dropdown-item>
                            <el-dropdown-item @click.native="addMonth(scope.row)">配额</el-dropdown-item>
                            <el-dropdown-item @click.native="chakanrizhi(scope.row)">挂号日志</el-dropdown-item>
                            <el-dropdown-item @click.native="deleteInfo(scope.row)">删除</el-dropdown-item>
                            <el-dropdown-item @click.native="checkTheAccounts(scope.row)">核验账密</el-dropdown-item>
                            <el-dropdown-item @click.native="clearToken(scope.row)">清除Token</el-dropdown-item>
                            <el-dropdown-item @click.native="copyVerbal(scope.row)">复制续费话术</el-dropdown-item>
                            <el-dropdown-item @click.native="copyLiberal(scope.row)">复制开通话术</el-dropdown-item>
                            <el-dropdown-item @click.native="chakanqk(scope.row)">配置和体力情况</el-dropdown-item>
                            <el-dropdown-item @click.native="openTt(scope.row)">开启极限偷桃</el-dropdown-item>
                            <el-dropdown-item @click.native="closeTt(scope.row)">关闭极限偷桃</el-dropdown-item>



                            <!-- 二级菜单项 -->
                            <!-- <el-dropdown-item>
                              <el-popover placement="left-start" trigger="hover" :offset="15">
                                <template #reference>
                                  <span>更多话术</span>
                                </template>

                                <el-menu v-for="(item, index) in menuItems" :default-active="$route.meta.route" router>
                                  <el-tooltip placement="top">
                                    <div slot="content">  {{ item.label }} </div>
                                    <el-dropdown-item @click.native="copyToClipboard(item.label)"> {{ item.name }}</el-dropdown-item>
                                  </el-tooltip>
                                </el-menu>

                              </el-popover>
                            </el-dropdown-item> -->

                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                  </template>
                </el-table-column>
              </el-table>
            </div>
        </div> 
      </el-tab-pane>
      <el-tab-pane label="待处理用户" name="second">
        <div>
          <div>
              <el-form :inline="true" label-position="right" size="default">
                <el-row :gutter="24">
                  
                  <el-col :span="10" type="flex" class="panda-search-row-button-group" justify="end">
                    <el-form-item>
                      <el-button type="primary" @click="chaxunBs(2)">查询全部账号</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>

            <div>
              <el-table max-height="482" v-loading="loading"
                  element-loading-text="正在加载..."
                  element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="items2" stripe  border size="default" style="width: 80%">
                <el-table-column align="center" label="序号" fixed>
                  <template #default="scope">
                    {{(scope.$index + 1)}}
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="username" label="账号" />
                <el-table-column align="center" prop="serverName" label="区服" />
                <el-table-column align="center" prop="nickName" label="角色名" />
                <el-table-column align="center" prop="enabled" label="启用状态" >
                  <template #default="scope">
                    <el-tag v-if="scope.row.enabled" type="success">已开启</el-tag>
                    <el-tag v-else type="danger">未开启</el-tag>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="startDate" label="生效时间" />
                <el-table-column align="center" prop="startDate" label="剩余天数"  :formatter="shengyutianshu"/>
                <el-table-column align="center" fixed="right" label="操作" width="150px" >
                  <template #default="scope">
                      <div style="display: flex;">
                        <el-button link type="primary" size="mini" @click="tongguo(scope.row)">通 过</el-button>
                        <el-button link type="primary" size="mini" @click="jujue(scope.row)">拒 绝</el-button>
                      </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
        </div> 
      </el-tab-pane>
    </el-tabs>
      
      <div>
        <el-dialog title="添加账号（功能包含自动偷福地，10点领玉、树广告、青蛙等广告激励自动领取）" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
          <el-form :model="form">
            <el-form-item label="是否启用" :label-width="formLabelWidth">
              <el-checkbox v-model="form.enabled"></el-checkbox>
            </el-form-item>
            <el-form-item label="账号" :label-width="formLabelWidth">
              <el-input v-model="form.username" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="密码" :label-width="formLabelWidth">
              <el-input v-model="form.password" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="授权码" :label-width="formLabelWidth">
              <el-input v-model="form.admin" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="区服（xx山xx服）" :label-width="formLabelWidth">
              <el-input v-model="form.serverName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="福地规则" :label-width="formLabelWidth">
              <div v-for="item in form.rules">
                <el-checkbox v-model="item.isCheck"></el-checkbox>
                <el-select v-model="item.minItemLv" placeholder="请选择">
                  <el-option key="1" :label="1" :value="1"/>
                  <el-option key="2" :label="2" :value="2"/>
                  <el-option key="3" :label="3" :value="3"/>
                  <el-option key="4" :label="4" :value="4"/>
                  <el-option key="5" :label="5" :value="5"/>
                </el-select>
                {{ item.description }}
              </div>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div>
        <el-dialog title="编辑账号（功能包含自动偷福地，10点领玉、树广告、青蛙等广告激励自动领取）" width="70%" :visible.sync="dialogFormVisibleBJ" :close-on-click-modal="false">
          <el-form :model="formBJ">
            <el-form-item label="是否启用" :label-width="formLabelWidth">
              <el-checkbox v-model="formBJ.enabled"></el-checkbox>
            </el-form-item>
            <el-form-item label="账号" :label-width="formLabelWidth">
              <el-input v-model="formBJ.username" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="密码" :label-width="formLabelWidth">
              <el-input v-model="formBJ.password" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="授权码" :label-width="formLabelWidth">
              <el-input v-model="formBJ.admin" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="区服（xx山xx服）" :label-width="formLabelWidth">
              <el-input v-model="formBJ.serverName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="角色名" :label-width="formLabelWidth">
              <el-input v-model="formBJ.nickName" autocomplete="off" disabled></el-input>
            </el-form-item>

            <el-form-item label="自动异兽入侵" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认不开启，需要开启请勾选，自动挑战异兽入侵">
                    <div slot="content">默认不开启，需要开启请勾选，自动异兽入侵</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="formBJ.invadeEnabled"></el-checkbox>
            </el-form-item>

            <el-form-item label="异兽入侵挑战分身" v-if="formBJ.invadeEnabled" :label-width="formLabelWidth">
                <div style="display: flex;">
                  <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="选择异兽入侵挑战分身，默认元体">
                    <div slot="content">选择异兽入侵挑战分身，默认元体</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-select v-model="formBJ.invadeIndex" collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in invadeIndexList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>

            <el-form-item label="妖王挑战次数：" :label-width="formLabelWidth">
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">妖王挑战次数：</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>&nbsp;&nbsp;
              <el-input-number v-model="formBJ.demonKingNum" :min="2" :max="8" label="妖王挑战次数："></el-input-number>
            </el-form-item>

            <el-form-item label="自动星宿试炼" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认不开启，需要开启请勾选，自动使用当前分身挑战星宿试炼">
                    <div slot="content">默认不开启，需要开启请勾选<br/>自动使用当前分身挑战星宿试炼</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="formBJ.starTrialEnabled"></el-checkbox>
            </el-form-item>

            <el-form-item label="自动宗门训练" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认不开启，需要开启请勾选，自动训练并出师">
                    <div slot="content">默认不开启，需要开启请勾选，自动训练并出师</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="formBJ.pupilEnabled"></el-checkbox>
            </el-form-item>

            <el-form-item label="自动砍树" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认不开启，需要开启请勾选，当晚4点-7点会自动砍树">
                    <div slot="content">默认不开启，需要砍树请勾选，当晚4点-7点会自动砍树<br/>PS: 没开分身前千万不要开启否则会封号</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="formBJ.chopTreeEnabled"></el-checkbox>
            </el-form-item>
            <el-form-item label="砍树桃子阈值：" v-if="formBJ.chopTreeEnabled" :label-width="formLabelWidth">
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">桃子低于该数字时砍树停止，默认500</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>&nbsp;&nbsp;
              <el-input-number v-model="formBJ.chopStopNum" :min="100" :max="200000" label="砍树桃子阈值"></el-input-number>
            </el-form-item>
            <el-form-item label="砍树一天数量：" v-if="formBJ.chopTreeEnabled" :label-width="formLabelWidth">
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">桃子低于该数字时砍树停止，默认500</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>&nbsp;&nbsp;
              <el-input-number v-model="formBJ.chopStopOneDayNum" :min="100" :max="20000" label="砍树一天数量："></el-input-number>
            </el-form-item>
            <el-form-item label="砍树等级阈值：" v-if="formBJ.chopTreeEnabled" :label-width="formLabelWidth">
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">人物等级大于等于该数字时砍树停止，默认9999</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>&nbsp;&nbsp;
              <el-input-number v-model="formBJ.chopStopLevel" :min="236" :max="9999" label="砍树等级阈值"></el-input-number>
            </el-form-item>
            <el-form-item label="元体装备属性设置：" v-if="formBJ.chopTreeEnabled" :label-width="formLabelWidth">
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">可多选，第一个选择装备属性，第二个选择装备抗性</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>
              <div>
                <el-select v-model="formBJ.yuanChopStats" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in chopTreeStats" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="formBJ.yuanChopResistances" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in chopTreeResistances" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="阳神装备属性设置：" v-if="formBJ.chopTreeEnabled" :label-width="formLabelWidth">
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">可多选，第一个选择装备属性，第二个选择装备抗性</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>
              <div>
                <el-select v-model="formBJ.yangChopStats" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in chopTreeStats" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="formBJ.yangChopResistances" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in chopTreeResistances" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="阴身装备属性设置：" v-if="formBJ.chopTreeEnabled" :label-width="formLabelWidth">
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">可多选，第一个选择装备属性，第二个选择装备抗性</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>
              <div>
                <el-select v-model="formBJ.yingChopStats" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in chopTreeStats" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="formBJ.yingChopResistances" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in chopTreeResistances" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="自动斗法" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认不开启，开启后挂号期间斗法卷存量达到上限时会进行2次人机斗法">
                    <div slot="content">默认不开启<br/>开启后挂号期间斗法卷存量达到上限时会进行2次人机斗法</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="formBJ.fightEnabled" ></el-checkbox>
            </el-form-item>
            <el-form-item label="自动偷福地" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，关闭后将不再自动偷福地，请谨慎操作">
                    <div slot="content">默认开启<br/>关闭后将不再自动偷福地，请谨慎操作</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="formBJ.homelandEnabled" ></el-checkbox>
            </el-form-item>
            <el-form-item label="福地偷取22:00至01:00" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，关闭后将不再自动偷福地，请谨慎操作">
                    <div slot="content">默认开启<br/>关闭后将不再自动偷福地，请谨慎操作</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="formBJ.homeland_2200_0100" ></el-checkbox>
            </el-form-item>

            <el-form-item label="福地偷取01:00至03:00" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，关闭后将不再自动偷福地，请谨慎操作">
                    <div slot="content">默认开启<br/>关闭后将不再自动偷福地，请谨慎操作</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="formBJ.homeland_0100_0300" ></el-checkbox>
            </el-form-item>

            <el-form-item label="福地偷取03:00至07:00" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，关闭后将不再自动偷福地，请谨慎操作">
                    <div slot="content">默认开启<br/>关闭后将不再自动偷福地，请谨慎操作</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="formBJ.homeland_0300_0700" ></el-checkbox>
            </el-form-item>

            <el-form-item label="福地偷取10:30至14:00" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，关闭后将不再自动偷福地，请谨慎操作">
                    <div slot="content">默认开启<br/>关闭后将不再自动偷福地，请谨慎操作</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="formBJ.homeland_1030_1400" ></el-checkbox>
            </el-form-item>

            <el-form-item label="福地偷取14:00至16:00" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，关闭后将不再自动偷福地，请谨慎操作">
                    <div slot="content">默认开启<br/>关闭后将不再自动偷福地，请谨慎操作</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="formBJ.homeland_1400_1600" ></el-checkbox>
            </el-form-item>

            <el-form-item label="福地偷取18:00至19:30" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，关闭后将不再自动偷福地，请谨慎操作">
                    <div slot="content">默认开启<br/>关闭后将不再自动偷福地，请谨慎操作</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp; 
                <el-checkbox v-model="formBJ.homeland_1800_1930" ></el-checkbox>
            </el-form-item>
            
            <el-form-item label="自动法则试炼" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，不可取消">
                    <div slot="content">默认开启，不可取消</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="fazeEnabled" disabled></el-checkbox>
            </el-form-item>
            <el-form-item label="自动仙友游历" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，不可取消">
                    <div slot="content">默认开启，不可取消</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="youliEnabled" disabled></el-checkbox>
            </el-form-item>
            <el-form-item label="自动看广告" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，不可取消">
                    <div slot="content">默认开启，不可取消<br/>自动观看树、青蛙、精怪、神通、法宝、宗门、聚灵阵广告</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="guanggaoEnabled" disabled></el-checkbox>
            </el-form-item>
            <el-form-item label="自动仙官领玉" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，不可取消">
                    <div slot="content">默认开启，不可取消<br/>挂号期间自动点击仙官弹窗领取仙玉</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="lingyuEnabled" disabled></el-checkbox>
            </el-form-item>
            <el-form-item label="自动妖盟任务" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，不可取消">
                    <div slot="content">默认开启，不可取消<br/>自动砍价、请战等</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="kanjiaEnabled" disabled></el-checkbox>
            </el-form-item>
            <el-form-item label="自动推图" :label-width="formLabelWidth">
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认不开启，需要开启请勾选">
                    <div slot="content">默认不开启，需要开启请勾选<br/>自动挑战冒险/真火秘境/镇妖塔<br/>开发中，敬请等待</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="formBJ.challengeEnabled" disabled></el-checkbox>
            </el-form-item>

            <el-form-item label="福地规则" :label-width="formLabelWidth">
              <div v-for="item in formBJ.rules">
                <el-checkbox v-model="item.isCheck"></el-checkbox>
                <el-select v-model="item.minItemLv" placeholder="请选择">
                  <el-option key="1" :label="1" :value="1"/>
                  <el-option key="2" :label="2" :value="2"/>
                  <el-option key="3" :label="3" :value="3"/>
                  <el-option key="4" :label="4" :value="4"/>
                  <el-option key="5" :label="5" :value="5"/>
                </el-select>
                {{ item.description }}
              </div>
            </el-form-item>

            <el-form-item label="顶号间隔" :label-width="formLabelWidth">
              <div>
                <el-radio-group v-model="formBJ.topSpacing">
                  <el-radio label="1" size="large">5 分钟</el-radio>
                  <el-radio label="2" size="large">10 分钟</el-radio>
                  <el-radio label="3" size="large">15 分钟</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisibleBJ = false">取 消</el-button>
            <el-button type="primary" @click="submitEdit">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div>
        <el-dialog title="管理员验证" :visible.sync="adminV" >
          <el-form :model="admin">
            <el-form-item label="请输入管理员密码" :label-width="formLabelWidth">
              <el-input v-model="admin.password" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="va">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div>
        <el-dialog title="日志查询" :visible.sync="dialogFormVisibleCR" >
          <div style="white-space: pre-wrap; ">{{ rizhi }}</div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogFormVisibleCR = false">关 闭</el-button>
          </div>
        </el-dialog>
      </div>
      <div>
        <el-dialog title="配额" :visible.sync="quotaV" width="35%">
          <el-form :model="admin">
            <el-form-item label="日期" label-width="60px">
              <el-input v-model="quota" autocomplete="off" style="margin-right: 50px;" @input="quotaChange"></el-input>
            </el-form-item>
            <el-form-item label="计算值" label-width="60px">
              {{ quotaNum }} 天
            </el-form-item>
            
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="quotaSubmit">确 定</el-button>
          </div>
        </el-dialog>
      </div>


      <div>
        <el-dialog title="极限福地到期配置" :visible.sync="limit_dialog" width="35%">
          <el-form >
            <el-form-item label="到期时间" label-width="90px">
              <el-input v-model="limit_date" autocomplete="off" style="margin-right: 50px;" @input="limitChange"></el-input>
            </el-form-item>
            <el-form-item label="计算值" label-width="60px">
              {{ limit_num }} 天
            </el-form-item>
            
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="limitSubmit">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      
    </div>
  
</template>

<script>
import axios from 'axios'
// import jsonFile from '@/assets/json/account.json';
// import qufu from '@/assets/json/qufu.json';
import {Message} from 'element-ui';
export default {
  name: "ask",
  data() {
    return {
      activeName: 'first',
      searchValue: {
        loginId: '',
      },
      oldUserName: '',
      admin: {
        password: '',
      },
      adminV: false,
      quotaV: false,
      limit_dialog: false,
      limit_id: null,
      limit_date: '',
      limit_num: '',
      chaxunB: 1,
      rizhi: '',
      qk: '',
      form: {
          enabled: true,
          username: '',
          password: '',
          admin: '',
          serverName: '',
          topSpacing: '1',
          rules: [
              { "ItemId": 100004, "minItemLv": 3, "isCheck": true, "description": "仙桃" },
              { "ItemId": 100025, "minItemLv": 4, "isCheck": true, "description": "净瓶水" },
              { "ItemId": 100000, "minItemLv": 5, "isCheck": false, "description": "仙玉" },
              { "ItemId": 100003, "minItemLv": 5, "isCheck": false, "description": "灵石" },
              { "ItemId": 100029, "minItemLv": 5, "isCheck": false, "description": "琉璃珠" },
              { "ItemId": 100044, "minItemLv": 5, "isCheck": false, "description": "天衍令" },
              { "ItemId": 100047, "minItemLv": 5, "isCheck": false, "description": "昆仑铁" }
          ],
        },
        formBJ: {
          challengeEnabled: false,
          invadeEnabled: false,
          demonKingNum: 2,
          invadeIndex: 0,
          starTrialEnabled: false,
          pupilEnabled: false,
          chopTreeEnabled: false,
          chopStopNum: 100,
          chopStopOneDayNum: 100,
          chopStopLevel: 9999,
          fightEnabled: false,
          homelandEnabled: true,

          homeland_2200_0100: false,
          homeland_0100_0300: false,
          homeland_0300_0700: false,
          homeland_1030_1400: false,
          homeland_1400_1600: false,
          homeland_1800_1930: false,
          
          
          yuanChopStats: [],
          yuanChopResistances: [],
          yangChopStats: [],
          yangChopResistances: [],
          yingChopStats: [],
          yingChopResistances: [],
        },

      quota: '',
      quotaNum: 0,
      quotaId: '',

      youliEnabled: true,
      fazeEnabled: true,
      guanggaoEnabled: true,
      kanjiaEnabled: true,
      lingyuEnabled: true,
      // 砍树相关
      chopTreeStats: [{ value: '5', label: '击晕' }, { value: '6', label: '暴击' }, { value: '7', label: '连击' }, 
      { value: '8', label: '闪避' }, { value: '9', label: '反击' },{ value: '10', label: '吸血' }],
      chopTreeResistances: [{ value: '11', label: '抗击晕' }, { value: '12', label: '抗暴击' }, { value: '13', label: '抗连击' }, 
      { value: '14', label: '抗闪避' }, { value: '15', label: '抗反击' },{ value: '16', label: '抗吸血' }],
      // 分身相关
      invadeIndexList: [{ value: 0, label: '元体' }, { value: 1, label: '阳神' }, { value: 2, label: '阴身' }],
      
      formLabelWidth: '200px',
      dialogFormVisible: false,
      dialogFormVisibleBJ: false,
      dialogFormVisibleCR: false,
      items: [],
      items2: [],
      serverInfo: [],
      data:[],

      options: [],

      menuItems: [],

      multipleSelection: [],

      uploadUrl: '',
      uploadRef: null,


      verbalTrick_1: '只要有月卡或者终身卡，可以在网页8元包月挂机……不用买云手机或者开电脑，是别人开服务器帮挂。\n\n· 自动偷桃瓶，省下鼠鼠管家\n· 自动砍树，自动斗法\n· 自动领玉，再也不用熬夜了\n\n此外还有自动星宿自动异兽，功能不是太多，且自动挂时段仅限22-10点，以及必须有月卡或年卡。\n\n优点是性价比奇高，一个月只要8块钱。',

      question: '',
      reply: '',
      loading: false,
      xloading: false,
      params: {
          "prompt": "",
          "userId": "#/chat/1682039457204",
          "network": true,
          "system": "",
          "withoutContext": false
      }
    }
  },
  
  beforeCreate() {
    document.querySelector('body').classList.add("overall1");
  },
  beforeDestroy() {
    document.querySelector('body').classList.remove("overall1");
  },

  mounted() {

    // this.ZhInfo();
    // this.ZhInfoDCL();
    // this.quInfo();

    // 加载话术合集
    this.loadVerbalTrick();
    
  },

  methods: {
    
    loadVerbalTrick() {
      this.getRequest("xundao/loadVerbalTrick").then(resp => {
        if (resp) {
          this.menuItems = resp.obj
        }
      });
    },

    daysBetweenDates(dateString1, dateString2) {
      // 将日期字符串转换为Date对象
      var date1 = new Date(dateString1);
      var date2 = new Date(dateString2);

      // 检查日期是否有效
      if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
          throw new Error('Invalid date');
      }

      // 计算两个日期之间的时间差（以毫秒为单位）
      var diffInMs = Math.abs(date2 - date1);

      // 转换为天数
      var diffInDays = diffInMs / (1000 * 60 * 60 * 24);

      return Math.floor(diffInDays);
    },


    ZhInfo() {
      this.getRequest("xundao/AllZh").then(resp => {
        this.loading = false;
        if (resp) {
          this.items = resp.obj
        }
      });
    },

    va() {
      this.getRequest("xundao/verifyAdmin?password=" + this.admin.password).then(resp => {
        if (resp && resp.obj == true) {
          this.adminV = false;
          if(this.chaxunB == 1) {
            this.ZhInfo();
          } else if(this.chaxunB == 2) {
            this.ZhInfoDCL();
          }
        }
      });
    },

    ZhInfoDCL() {
      this.getRequest("xundao/AllZhDCL").then(resp => {
        this.loading = false;
        if (resp) {
          this.items2 = resp.obj
        }
      });
    },

    tongguo(row) {
      this.getRequest("xundao/tongguo?id=" + row.username).then(resp => {
        if (resp) {
          this.ZhInfoDCL();
        }
      });
    },

    jujue(row) {
      this.getRequest("xundao/jujue?id=" + row.username).then(resp => {
        if (resp) {
          this.ZhInfoDCL();
        }
      });
    },

    quInfo() {
      this.getRequest("xundao/AllQf").then(resp => {
        if (resp) {
          this.serverInfo = resp.obj
        }
      });
    },

    ZhOne() {
      this.getRequest("xundao/zh?id=" + this.searchValue.loginId).then(resp => {
        this.loading = false;
        if (resp) {
          this.items = resp.obj
        }
      });
    },

    handleClick(tab, event) {
        console.log(tab, event);
      },

    shengyutianshu(row, column) {
      var property = row[column.property];
      if("9999-12-31" == property) {
        return "无限期";
      } else {
        var now = new Date();
        var year = now.getFullYear();
        var month = ('0' + (now.getMonth() + 1)).slice(-2); // getMonth() 是 0-based 的
        var day = ('0' + now.getDate()).slice(-2);
        let m = this.daysBetweenDates(property, year + '-' + month + '-' + day)

        var date1 = new Date(property);
        var date2 = new Date();

        if(date1 > date2) {
          return 30 + m;
        } else {
          let n = 30 - m;
          if(n < 0) {
            return 0;
          }
          return 30 - m;
        }
      }
    },

    shengyutianshu2(property) {

      try {
        if("9999-12-31" == property) {
        return "无限期";
      } else {
        var now = new Date();
        var year = now.getFullYear();
        var month = ('0' + (now.getMonth() + 1)).slice(-2); // getMonth() 是 0-based 的
        var day = ('0' + now.getDate()).slice(-2);
        let m = this.daysBetweenDates(property, year + '-' + month + '-' + day)

        var date1 = new Date(property);
        var date2 = new Date();

        if(date1 > date2) {
          return 30 + m;
        } else {
          let n = 30 - m;
          if(n < 0) {
            return 0;
          }
          return 30 - m;
        }
      }
      } catch (error) {
        return 0;
      }
    },

    shengyuLimit(property) {
      try {
        // 特殊值：无限期
        if ("9999-12-31" == property) {
          return "无限期";
        }

        // 解析传入日期和当前日期
        const targetDate = new Date(property);
        const today = new Date();

        // 设置时间为 00:00:00，只比较日期部分
        const target = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());
        const now = new Date(today.getFullYear(), today.getMonth(), today.getDate());

        // 计算相差天数
        const diffTime = target - now;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // 毫秒转天数

        // 如果目标日期大于今天，返回差值；否则返回 0
        return diffDays > 0 ? diffDays : 0;

      } catch (error) {
        console.error("日期解析出错:", error);
        return 0;
      }
    },  

    addZh() {
      this.form = {
          enabled: true,
          username: '',
          password: '',
          serverName: '',
          rules: [
              { "ItemId": 100004, "minItemLv": 3, "isCheck": true, "description": "仙桃" },
              { "ItemId": 100025, "minItemLv": 4, "isCheck": true, "description": "净瓶水" },
              { "ItemId": 100000, "minItemLv": 5, "isCheck": false, "description": "仙玉" },
              { "ItemId": 100003, "minItemLv": 5, "isCheck": false, "description": "灵石" },
              { "ItemId": 100029, "minItemLv": 5, "isCheck": false, "description": "琉璃珠" },
              { "ItemId": 100044, "minItemLv": 5, "isCheck": false, "description": "天衍令" },
              { "ItemId": 100047, "minItemLv": 5, "isCheck": false, "description": "昆仑铁" }
          ],
        }
      this.dialogFormVisible = true
    },

    zhBJ(row) {
      this.formBJ = row;
      this.dialogFormVisibleBJ = true;

      this.formBJ.yuanChopStats = this.formBJ.yuanChopStats.map(String);
      this.formBJ.yuanChopResistances = this.formBJ.yuanChopResistances.map(String);
      this.formBJ.yangChopStats = this.formBJ.yangChopStats.map(String);
      this.formBJ.yangChopResistances = this.formBJ.yangChopResistances.map(String);
      this.formBJ.yingChopStats = this.formBJ.yingChopStats.map(String);
      this.formBJ.yingChopResistances = this.formBJ.yingChopResistances.map(String);

      this.oldUserName = row.username;

    },

    chakanrizhi(row) {
      this.dialogFormVisibleCR = true
      this.getRequest("xundao/rzck?id=" + row.username).then(resp => {
        if (resp) {
          this.rizhi = resp.obj
        }
      });
    },

    chakanqk(row) {
      this.getRequest("xundao/qkck?id=" + row.username).then(resp => {
        if (resp) {
          this.qk = resp.obj
        }
      });
    },

    deleteInfo(row) {
      this.$confirm('请确认删除此账号！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const id = row.username;
          // 获取所有查询参数
          const queryParams = this.$route.query;
          // 获取单个参数值
          const adminPassword = this.$route.query.w;

          this.getRequest("xundao/deleteInfo?username=" + id + "&adminPassword=" + adminPassword ).then(resp => {
            if (resp) {
              this.chaxunBs(1);
            }
          });
        }).catch(() => {
                  
        });
    },


    openTt(row) {

      this.limit_id = row.username;
      this.limit_dialog = true;

      // 获取今天的日期并格式化为 YYYY-MM-DD
      const today = new Date();
      const futureDate = new Date(today);
      futureDate.setDate(today.getDate() + 30); // 加30天
      const year = futureDate.getFullYear();
      const month = String(futureDate.getMonth() + 1).padStart(2, '0');
      const day = String(futureDate.getDate()).padStart(2, '0');
      this.limit_date = `${year}-${month}-${day}`;


      this.limit_num = this.shengyuLimit(this.limit_date);

      // this.$confirm('请确认开启极限偷桃！', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     const id = row.username;
      //     // 获取所有查询参数
      //     const queryParams = this.$route.query;
      //     // 获取单个参数值
      //     const adminPassword = this.$route.query.w;

      //     this.getRequest("xundao/open/limit-homeland?username=" + id + "&adminPassword=" + adminPassword ).then(resp => {
      //       if (resp) {
      //       }
      //     });
      //   }).catch(() => {
                  
      //   });
    },

    closeTt(row) {
      this.$confirm('请确认关闭极限偷桃！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const id = row.username;
          // 获取所有查询参数
          const queryParams = this.$route.query;
          // 获取单个参数值
          const adminPassword = this.$route.query.w;

          this.getRequest("xundao/close/limit-homeland?username=" + id + "&adminPassword=" + adminPassword ).then(resp => {
            if (resp) {
            }
          });
        }).catch(() => {
                  
        });
    },

    clearToken(row) {
      this.$confirm('请确认清除Token！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const id = row.username;

          this.getRequest("xundao/clearToken?username=" + id).then(resp => {
            if (resp) {
              
            }
          });
        }).catch(() => {
            
        });
    },

    checkTheAccounts(row) {
      this.$confirm('请确认核验账密！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const id = row.username;
          // 获取所有查询参数
          const queryParams = this.$route.query;
          // 获取单个参数值
          const adminPassword = this.$route.query.w;

          this.getRequest("xundao/checkTheAccounts?username=" + id + "&adminPassword=" + adminPassword ).then(resp => {
            if (resp) {
              this.chaxunBs(1);
            }
          });
        }).catch(() => {
            
        });
    },

    copyVerbal(row) {
      // const day = this.shengyutianshu2(row.startDate);
      // const title = day > 0 ? "临期通知\n" : "到期通知\n";
      console.log(row)
      const txt = row.username + "\n" +
            ""+ row.serverName + "\n" +
            ""+ row.nickName + "\n\n" +
            "脚本即将到期了，还需要续费吗？";
        this.copyToClipboard(txt);
    },

    copyLiberal(row) {
      const fullUrl = window.location.href; // 获取当前页面的完整URL
      const url = new URL(fullUrl); // 创建一个新的URL对象
      let port = url.port && url.port !== "80" && url.port !== "443" ? `:${url.port}` : '';
      const baseUrl = `${url.protocol}//${url.hostname}${port}`;
      const day = this.shengyutianshu2(row.startDate);

      const remainingDays = parseInt(day, 10);
      const today = new Date();
      const expireDate = new Date(today);
      expireDate.setDate(today.getDate() + remainingDays);

      const year = expireDate.getFullYear();
      const month = expireDate.getMonth() + 1; // 月份从0开始
      const date = expireDate.getDate();

      // 格式化为：2025年8月13日
      const expireStr = `${year}年${month}月${date}日`;


      let huaSu = "已开通 "+ day + " 天，到期时间："+expireStr+"。\n" ;

      if(day == "无限期") {
        huaSu = "已开通永久🌹🌹🌹\n" ;
      }

      const txt = 
            "账号：" + row.username + "\n" +
            "区服：" + row.serverName + "\n" +
            "角色名：" + row.nickName + "\n\n" +
            huaSu 
            // +  "该账号管理网站为：" + baseUrl + "。后续修改辅助配置可以该网站中的账号管理进行设置。" 
            ;
        this.copyToClipboard(txt);
    },

    copyToClipboard(text) {
        // 创建一个临时的 textarea 元素
        const textarea = document.createElement("textarea");
        textarea.value = text;

        // 将 textarea 添加到文档中
        document.body.appendChild(textarea);

        // 选中文本框中的内容
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);

        // 执行复制命令
        try {
          const successful = document.execCommand('copy');
          if (successful) {
            Message.success({message: '复制成功！'})
          } else {
            Message.error({message: '复制失败，请检查浏览器权限。'})
          }
        } catch (err) {
          console.error("复制失败:", err);
        }

        // 移除临时的 textarea 元素
        document.body.removeChild(textarea);
      },

    chaxunBs(id) {
      this.chaxunB = id;
        // 获取所有查询参数
      const queryParams = this.$route.query;
      // 获取单个参数值
      const adminPassword = this.$route.query.w; 
      
      if(adminPassword) {
        this.getRequest("xundao/verifyAdmin?password=" + adminPassword).then(resp => {
        if (resp && resp.obj == true) {
          this.adminV = false;
          if(this.chaxunB == 1) {
            this.ZhInfo();
          } else if(this.chaxunB == 2) {
            this.ZhInfoDCL();
          }
        }
      });

      } else {
        this.adminV = true;
      }
    
    },

    submitAdd() {
      this.postRequest("xundao/add", this.form).then(resp => {
        if (resp && resp.status == "200") {
          this.dialogFormVisible = false
        }
      });
    },

    addMonth(row) {
      this.quota = row.startDate;
      this.quotaId = row.username;
      this.quotaV = true;

      this.quotaNum = this.shengyutianshu2(this.quota);
    },

    quotaChange() {
      this.quotaNum = this.shengyutianshu2(this.quota);
    },

    limitChange() {
      this.limit_num = this.shengyuLimit(this.limit_date);
    },

    quotaSubmit() {
      this.$confirm('请确认配额！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const quota = this.quota;
          const quotaId = this.quotaId;
          // 获取所有查询参数
          const queryParams = this.$route.query;
          // 获取单个参数值
          const adminPassword = this.$route.query.w;

          this.getRequest("xundao/quota?quotaId=" + quotaId + "&quota=" + quota + "&adminPassword=" + adminPassword ).then(resp => {
            if (resp) {
              this.chaxunBs(1);
              this.quotaV = false;

            }
          });
        }).catch(() => {
                  
        });
    },

    limitSubmit() {
      this.$confirm('请确认时间！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 获取单个参数值
          const adminPassword = this.$route.query.w;

          this.getRequest("xundao/open/limit-homeland?username=" + this.limit_id + "&limitDate=" + this.limit_date + "&adminPassword=" + adminPassword ).then(resp => {
            if (resp) {
              this.chaxunBs(1);
              this.limit_dialog = false;
            }
          });
        }).catch(() => {
                  
        });
    },

    submitEdit() {
      this.formBJ.oldUserName = this.oldUserName
      this.postRequest("xundao/editGR", this.formBJ).then(resp => {
        if (resp && resp.status == "200") {
          this.dialogFormVisibleBJ = false;
          this.chaxunBs(1);
        }
      });
    },

    handleSelectionChange(val) {
      // 提取 username 字段并生成字符串数组
      this.multipleSelection = val.map(item => item.username);
    },

    
    test(state) {

      this.getRequest("xundao/AllQf").then(resp => {
        this.loading = false;
        if (resp) {
          console.log(resp.obj)
        }
      });

    },

    checkQuery() {
      if(this.multipleSelection.length > 0) {
        this.getRequest("xundao/checkQuery?list=" + this.multipleSelection).then(resp => {
          if (resp) {
            this.items = resp.obj
          }
        });
      } else {
        Message.error({message: '没有选中的行'})
      }
    },

    checkExport() {
      if(this.multipleSelection.length > 0) {

        // 获取所有查询参数
        const queryParams = this.$route.query;
        // 获取单个参数值
        const adminPassword = this.$route.query.w;

        this.downloadRequest("xundao/checkExport?list=" + this.multipleSelection + "&adminPassword=" + adminPassword).then(resp => {
          if (resp) {
            this.items = resp.obj
          }
        });
      } else {
        Message.error({message: '没有选中的行'})
      }
    },

    checkImport() {
      //上传组件action
      let baseURL =  "";
      if(baseURL) {
        baseURL = baseURL.replace(/\//g, "") + "/";
      }
      this.uploadUrl = baseURL + "xundao/checkImport";

      // 确保组件渲染完成后触发文件选择框
      this.$nextTick(() => {
        const input = this.$refs.uploadRef.$el.querySelector('input[type="file"]');
        if (input) {
          input.click(); // 触发文件选择框
        } else {
          console.error("未找到文件输入框元素");
        }
      });
    },

    handleSuccess(response, file, fileList) {
      if (response && response.fileUrl) {
        this.$message.success("文件上传成功！");
      } else {
        this.$message.warning("服务器未返回有效数据，请检查接口！");
      }
    },
    handleError(error, file, fileList) {
      console.error("上传失败:", error, file, fileList);
      this.$message.error(error.message || "文件上传失败，请稍后重试！");
    },

    checkExportExcel() {
      if(this.multipleSelection.length > 0) {
        this.downloadRequest("xundao/checkExportExcel?list=" + this.multipleSelection).then(resp => {
          if (resp) {
            this.items = resp.obj
          }
        });
      } else {
        Message.error({message: '没有选中的行'})
      }
    },
    
  }
}
</script>

<style>
.loginContainer {
  background-clip: padding-box;
  width: 90%;
  height: 100%;
  margin-top: 120px;
  margin-left: 100px;
}

.overall1 {
  position: absolute;
  content: ' ';
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  background-image: url("../assets/image.png");
  background-size: cover;
}

.el-tooltip__popper {
  white-space: pre-wrap;
}

</style>
